import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import ItemService from "../../../../services/plm_appCommonService";
// import { InputField } from "../../../../Components/formElements/InputField";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { getArticleList } from "../../../../redux/feature/plm_app/plmSlice";

const UploadArticleModal = ({ show, onHide, onSuccessUpload, disabled }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(false);

  const dispatch = useDispatch();

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    // Properly inspect FormData content
    // for (let pair of formData.entries()) {
    //   console.log(`${pair[0]}:`, pair[1]);
    // }

    setUploadStatus(true);

    // Uncomment below when ready to call API
    try {
      const response = await ItemService.uploadArticleFile(formData);
      onSuccessUpload?.(response);
      toast.success("Upload successful!");
      let obj = {
      queryName: "GET_ARTICLE_LIST",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
      dispatch(getArticleList(obj));

      onHide(); // Close modal
    } catch (error) {
      toast.error("Upload failed:", error);
      alert("Upload failed.");
    } finally {
      setUploadStatus(false);
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Upload Excel File</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          className="inputBox w-100"
          type="file"
          accept=".csv, .xls, .xlsx"
          onChange={handleFileChange}
          disabled={uploadStatus || disabled}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-danger"
          onClick={onHide}
          disabled={uploadStatus}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary"
          onClick={handleUpload}
          disabled={uploadStatus || disabled}
        >
          {uploadStatus ? <Spinner animation="border" size="sm" /> : "Upload"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadArticleModal;
